'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { useBodyScrollLock } from '@common/hooks';
import SvgDelete from '@common/icon/SvgDelete';
import { cn } from '@core/utils';
import { useEffect, useId, useState } from 'react';
interface PartnersBlurOverlayProps {
  title: React.ReactNode;
  description: React.ReactNode;
  children: React.ReactNode;
  isSheetOnMobile?: boolean;
  onClose?: () => void;
}
export const PartnersBlurOverlay = t0 => {
  const $ = _c(41);
  const {
    title,
    description,
    children,
    isSheetOnMobile: t1,
    onClose
  } = t0;
  const isSheetOnMobile = t1 === undefined ? false : t1;
  const titleId = useId();
  const [dialogNode, setDialogNode] = useState(null);
  useBodyScrollLock(true);
  let t2;
  let t3;
  if ($[0] !== dialogNode) {
    t2 = () => {
      dialogNode?.focus();
    };
    t3 = [dialogNode];
    $[0] = dialogNode;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[3] !== onClose) {
    t4 = () => {
      if (!onClose) {
        return;
      }
      const handleKeyDown = event => {
        if (event.key === "Escape") {
          onClose();
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    };
    t5 = [onClose];
    $[3] = onClose;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  const t6 = isSheetOnMobile ? "backdrop-blur-[6px]" : "backdrop-blur-sm";
  const t7 = isSheetOnMobile && "mobile-tablet:top-0 mobile-tablet:items-end mobile-tablet:px-0";
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = cn("fixed inset-0 z-30 flex items-center justify-center bg-Gray-white/[0.55] px-20 mobile-tablet:top-48", "duration-200 animate-in fade-in", t6, t7);
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== onClose) {
    t9 = event_0 => {
      if (event_0.target === event_0.currentTarget) {
        onClose?.();
      }
    };
    $[9] = onClose;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = isSheetOnMobile ? "gap-24 mobile-tablet:max-w-full mobile-tablet:gap-40 mobile-tablet:rounded-t-large mobile-tablet:bg-Gray-white mobile-tablet:px-16 mobile-tablet:py-40" : "gap-20";
  let t11;
  if ($[11] !== t10) {
    t11 = cn("relative flex w-full max-w-[400px] flex-col items-center text-center outline-none", t10);
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== isSheetOnMobile || $[14] !== onClose) {
    t12 = onClose ? <button aria-label={"\uB2EB\uAE30"} className={cn("absolute right-16 top-16 rounded-pill p-4 text-Gray-700 transition-colors", "hover:bg-Gray-100 active:bg-Gray-200", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-B-500", !isSheetOnMobile && "hidden", "xl:hidden")} onClick={onClose}><SvgDelete className="size-24" /></button> : null;
    $[13] = isSheetOnMobile;
    $[14] = onClose;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const t13 = isSheetOnMobile ? "gap-12" : "gap-8";
  let t14;
  if ($[16] !== t13) {
    t14 = cn("flex flex-col", t13);
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const t15 = isSheetOnMobile ? "text-Gray-black typo-h3 mobile-tablet:typo-h5" : "text-Gray-900 typo-h7";
  let t16;
  if ($[18] !== t15) {
    t16 = cn("whitespace-pre-line break-keep font-700", t15);
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t16 || $[21] !== title || $[22] !== titleId) {
    t17 = <h2 id={titleId} className={t16}>{title}</h2>;
    $[20] = t16;
    $[21] = title;
    $[22] = titleId;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  const t18 = isSheetOnMobile ? "font-500 text-Gray-700 typo-body2 mobile-tablet:typo-body4" : "text-Gray-600 typo-body4";
  let t19;
  if ($[24] !== description || $[25] !== t18) {
    t19 = <p className={t18}>{description}</p>;
    $[24] = description;
    $[25] = t18;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t14 || $[28] !== t17 || $[29] !== t19) {
    t20 = <div className={t14}>{t17}{t19}</div>;
    $[27] = t14;
    $[28] = t17;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== children || $[32] !== t11 || $[33] !== t12 || $[34] !== t20 || $[35] !== titleId) {
    t21 = <div ref={setDialogNode} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1} className={t11}>{t12}{t20}{children}</div>;
    $[31] = children;
    $[32] = t11;
    $[33] = t12;
    $[34] = t20;
    $[35] = titleId;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t21 || $[38] !== t8 || $[39] !== t9) {
    t22 = <Portal renderTo={_temp}><div className={t8} onClick={t9}>{t21}</div></Portal>;
    $[37] = t21;
    $[38] = t8;
    $[39] = t9;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  return t22;
};
function _temp() {
  return document.body;
}